import moment from 'moment-timezone';

export const APP_TIMEZONE = process.env.REACT_APP_TIMEZONE || 'Europe/Moscow';

export const projectMoment = value => (value ? moment.tz(value, APP_TIMEZONE) : moment.tz(APP_TIMEZONE));

export const projectDateToISOString = (value, endOfDay = false) => {
  if (!value) {
    return value;
  }
  const dateValue = String(value);
  if (dateValue.includes('T')) {
    return dateValue;
  }
  const dateMoment = moment.tz(dateValue, 'YYYY-MM-DD', APP_TIMEZONE);
  if (!dateMoment.isValid()) {
    return value;
  }
  return (endOfDay ? dateMoment.endOf('day') : dateMoment.startOf('day')).toISOString();
};

export const projectDateToTimestamp = (value, endOfDay = false) => {
  const isoValue = projectDateToISOString(value, endOfDay);
  if (typeof isoValue === 'number') {
    return isoValue;
  }
  const timestamp = Date.parse(isoValue);
  return Number.isNaN(timestamp) ? value : timestamp;
};

export const getProjectPeriodDates = (type, reference = null) => {
  const today = reference ? projectMoment(reference) : projectMoment();
  let start = today.clone().startOf('day');
  let end = today.clone().endOf('day');
  if (type === 'y') {
    start = today.clone().startOf('year');
    end = today.clone().endOf('year');
  } else if (type === 'm') {
    start = today.clone().startOf('month');
    end = today.clone().endOf('month');
  } else if (type === 'w') {
    start = today.clone().startOf('week');
    end = today.clone().endOf('week');
  } else if (type === 'yd') {
    start = today.clone().subtract(1, 'day').startOf('day');
    end = today.clone().subtract(1, 'day').endOf('day');
  }
  return [start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD')];
};
